<template>
    <div :class="$style.container">
        <div>
          <svg 
            :class="[$style.close, 'lightbox__close__icon']"
            viewBox="0 0 17 16"
          >
            <g 
              stroke="#1B2838" 
              stroke-width="2" 
              fill="none" 
              fill-rule="evenodd" 
              stroke-linecap="round" 
              stroke-linejoin="round"
              class="lightbox__close__icon"
            >
              <path d="M1 1l15 14M16 1L1 15" class="lightbox__close__icon" />
            </g>
          </svg>
        </div>
        <div :class="[$style.imageContainer, 'shopkeep-to-lightspeed']"></div>
        <h2 :class="[$style.heading]">ShopKeep is now part of the Lightspeed&nbsp;family.</h2>
        <p :class="$style.body">Our team will help you find powerful POS solutions tailored to your&nbsp;business.</p>
        <a 
          :href="buttonUrl" 
          :class="$style.button" 
          @click.prevent="buttonClicked"
        >{{ buttonText }}</a>
    </div>
</template>

<style lang="scss" module>
  .container {
    padding: 50px 70px;
  }
  
  .close{
    cursor: pointer;
    position: absolute;
    right: 17px;
    top: 13px;
    width: 18px;

    @include breakpoint(sm){
      right: 23px;
    }
  }

  .heading {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 25px;
    font-weight: 300;
    line-height: 32px;
    margin: 0 auto;
    max-width: 366px;

    @include breakpoint(xs) {
      font-size: 32px;
      line-height: 40px;
    }
  }

  .body {
    color: $steel;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 14px;
    line-height: 22px;
    margin: 12px 0 30px;

    @include breakpoint(xs) {
      font-size: 16px;
      line-height: 25px;
    }
  }

  .imageContainer {
    margin: 0 auto 30px;
  }

  .button{
    background-color: $cerulean;
    border: none;
    border-radius: 28px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 15px;
    font-weight: 900;
    line-height: 16px;
    min-width: 181px;
    padding: 17px;
    text-decoration: none;
    transition: background-color 0.6s;

    &:hover, &:active, &:focus{
      background-color: $cerulean-100;
      color: #fff;
      outline: none;
    }

    @include breakpoint(sm){
      font-size: 15px;
    }
  }
</style>

<script>
/* globals dataLayer */

export default {
    computed: {
      buttonUrl() {
        return 'https://www.lightspeedhq.com/pos/shopkeep-by-lightspeed/';
      },
      buttonText() {
        return 'Learn More at Lightspeed';
      }
    },
    methods: {
      buttonClicked() {
        dataLayer.push({
          event: 'popup',
          fieldValue: this.buttonText,
          popupAction: 'Click',
          popupType: 'Lightspeed'
        });
        window.open(this.buttonUrl);
      }
    }
};
</script>